import React from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { ClipLoader } from 'react-spinners'
import { removeParticipant } from '../../../actions/currentConversation/removeParticipant'
import { addParticipant } from '../../../actions/currentConversation/addParticipant'

export const ConversationMembersModal = ({ show, handleClose: onClose, recipients }) => {
  const dispatch = useDispatch()
  const [ loading, setLoading ] = React.useState(false)
  const [ showAddParticipant, setShowAddParticipant ] = React.useState(false)
  const potentialParticipants = useSelector(state=>state.recipients)

  function handleRemove(recipient){
    setLoading(true)
    dispatch(removeParticipant(recipient)).then(()=>setLoading(false))
  }

  function handleAddParticipant(recipient){
    setLoading(true)
    dispatch(addParticipant(recipient)).then(()=>{
      setShowAddParticipant(false)
      setLoading(false)
    })
  }

  function handleClose(){
    onClose()
    setShowAddParticipant(false)
  }

  return(
    <Modal show={show} onHide={handleClose}>
      {
        showAddParticipant ? 
        <AddParticipant {...{ recipients, setShowAddParticipant, handleClose, loading, handleAddParticipant, potentialParticipants }}/> :
        <ConversationMembersList {...{ handleClose, recipients, setShowAddParticipant, loading, handleRemove }}/>
      }
    </Modal>
  )
}

function AddParticipant({ recipients, setShowAddParticipant, handleAddParticipant, handleClose, potentialParticipants, loading }) {
  let alreadyRecipientIds = recipients.map(recipient=>recipient.id)
  let allowedCandidates = potentialParticipants.filter(participant=>!alreadyRecipientIds.includes(participant.id))
  const [ filter, setFilter ] = React.useState('')

  return(
    <>
      <div className="pl-4 pr-4 pt-3 pb-3 card-header d-flex justify-content-between align-items-center">
        <>Add Participant</>
        <div className="btn btn-primary btn-sm" onClick={handleClose}><div className="fas fa-times" /></div>
      </div>
      <div className="overflow-y-scroll">
        <input
          value={filter}
          onChange={(e)=>setFilter(e.target.value)}
          className="form-control py-4"
          placeholder="Filter..."/>
        {
          allowedCandidates.filter(candidate=>candidate.name.toLowerCase().includes(filter.toLowerCase())).map(recipient=>(
            <div key={recipient.id} className="p-4 border-bottom hoverable clickable d-flex justify-content-between align-items-center">
              <div className="w-100">
                <b>{recipient.name}</b>
                <div>
                  {
                    recipient.role_names && recipient.role_names.map((roleName, index)=>(
                      <div key={index} className="badge badge-primary text-capitalize">{roleName}</div>
                    ))
                  }
                </div>
              </div>
              <button disabled={loading} className="btn btn-sm btn-primary ml-3" onClick={()=>handleAddParticipant(recipient)}> { loading ? <ClipLoader size={16} color='white'/> : 'Add' }</button>
            </div>
          ))
        }
      </div>
      <div className="p-4 text-center">
        <button className="btn btn-primary" onClick={()=>setShowAddParticipant(false)}>Cancel</button>
      </div>
    </>
  )
}

function ConversationMembersList({ handleClose, recipients, loading, handleRemove, setShowAddParticipant }) {
  return(
    <>
      <div className="pl-4 pr-4 pt-3 pb-3 card-header d-flex justify-content-between align-items-center">
        <>Conversation Members</>
        <div className="btn btn-primary btn-sm" onClick={handleClose}><div className="fas fa-times" /></div>
      </div>
      <div className="overflow-y-scroll">
        {
          recipients && recipients.map(recipient=>(
            <div key={recipient.id} className="p-4 border-bottom hoverable clickable d-flex justify-content-between align-items-center">
              <div className="w-100">
                <b>{recipient.name}</b>
                <div>
                  {
                    recipient.role_names && recipient.role_names.map((roleName, index)=>(
                      <div key={index} className="badge badge-primary text-capitalize">{roleName}</div>
                    ))
                  }
                </div>
              </div>
              { recipients.length > 1 && <button disabled={loading} className="btn btn-xs btn-outline-danger" onClick={()=>handleRemove(recipient)}> { loading ? <ClipLoader size={16} color='red'/> : 'Remove' }</button> }
            </div>
          ))
        }
        <div className="p-4 text-center">
          <button className="btn btn-primary" onClick={()=>setShowAddParticipant(true)}>Add Participant</button>
        </div>
      </div>
    </>
  )
}
